import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const VoiceJourneyLoader = styled(Box)(({ theme }) => ({
  width: '60px',
  height: '60px',
  border: '8px solid #f3f3f3',
  borderTop: '8px solid #514b82',
  borderRadius: '50%',
  animation: 'spin 2s linear infinite',
  
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
}));

export default VoiceJourneyLoader;
